// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c0d4e027","453":"5c9c910f","455":"d1785444","977":"29356661"}[chunkId] + ".chunk.js";
};